function handleAtc (id, handle) {
    var self = window.side_cart;
    if (id) {
        const existingMinis = self.cart_items.filter((it) => it.properties && it.properties._free_mini === 'yes' && it.handle === handle);
        if (existingMinis.length > 0) {
            const lpErrorEl = document.querySelector(`.product-item__form-lp--error[data-id="${id}"]`)
            if (lpErrorEl) {
                lpErrorEl.classList.add('show');
                setTimeout(() => {
                    lpErrorEl.classList.remove('show')
                }, 4000)
            }
            return false;
        }
        var items = [];
        var item = {
            id: id,
            quantity: 1,
            properties: {
                _free_mini: 'yes',
                _free_mini_handle: handle
            }
        }
        items.push(item);
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: items
            },
            dataType: 'json',
            success: async function (data) {
                console.log('success', data);

                self.toggle_sidecart();

                const newCartItems = data.items.concat(self.cart_items);
                self.cart_items = newCartItems;

                self.cart = await fetch('/cart.js').then((e) => e.json());

                self.total_price_post_dc = self.cart_items.reduce((a, b) => { return a + parseFloat(b.original_price*b.quantity) }, 0);
                self.discounts_used.forEach((discount) => {
                    self.apply_promo_code('atc', discount.discount_code);
                });

                self.initUpsells()
                self.processAutoGwp('atc', id);

            },
            error: function(data) {
                
                window.console.log(data);
                if (data.responseJSON && data.responseJSON.status === 422 && data.responseJSON.message.includes('Your cart includes a free mini you\'ve already claimed. Please remove it to continue.')) {
                    var errorEl = document.getElementById('lp-free-mini-error');
                    if (errorEl) {
                        errorEl.style.display = 'block';
                        // Allow a brief reflow before adding the class for the transition
                        requestAnimationFrame(function() {
                            errorEl.classList.add('show');
                        });
                        errorEl.classList.remove('show');
                    }
                }
            }
        });
    }
}